<div class="modal-header border-0 px-lg-5 px-2">
	<span class="modal-title theme-main-color fs-4 fw-bold ms-2 mt-3"
		>Modification</span
	>
	<button
		type="button"
		class="btn-close"
		data-bs-dismiss="modal"
		aria-label="Close"
		(click)="bsModalRef.hide()"
	></button>
</div>

<div class="modal-body">
	<div class="row px-lg-5 px-2">
		<div class="">
			<div class="row">
				<span class="theme-main-color fs-4 col">Informations</span>
				<button
					class="col-2 btn theme-red-button"
					(click)="openModal(deleteTauxReconnaissance)"
				>
					<i class="bi bi-trash-fill" aria-hidden="true"></i>
				</button>
			</div>
			<div class="row my-2">
				<form id="formEdit" [formGroup]="formEdit" (ngSubmit)="onSubmit()">
					<div class="row my-4">
						<label for="name" class="form-label theme-main-color fw-bold"
							>Nom</label
						>
						<input
							autocomplete="off"
							type="text"
							class="form-control"
							id="name"
							name="name"
							formControlName="name"
							[ngClass]="{
								'is-invalid': name.invalid,
								'is-valid': name.dirty && name.valid
							}"
						/>
						<div
							*ngIf="name.invalid && (name.dirty || name.touched)"
							class="text-danger"
						>
							<span *ngIf="name.errors?.required"> Un nom est requis</span>
							<span *ngIf="name.errors?.pattern">
								Le nom ne peut pas comporter de chiffre</span
							>
							<span *ngIf="name.errors?.maxLength"> Le nom est trop long</span>
						</div>
					</div>

					<div class="row my-5">
						<div class="d-flex justify-content-end">
							<button
								class="btn theme-main-color-button mx-3 px-3"
								type="button"
								(click)="bsModalRef.hide()"
							>
								Retour
							</button>
							<button
								[disabled]="!formEdit.valid || isValidateButtonClicked"
								class="btn theme-green-button"
								type="submit"
								form="formEdit"
							>
								<i class="bi bi-save-fill px-1" aria-hidden="true"></i
								>Sauvegarder
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>

<ng-template #deleteTauxReconnaissance>
	<div class="modal-header text-center">
		<h4>Suppression de la specialite</h4>
		<button
			type="button"
			class="btn-close"
			aria-label="Close"
			(click)="confirmDeleteModalRef.hide()"
		></button>
	</div>
	<div class="modal-body">
		Êtes-vous sûr de vouloir supprimer la specialite ?
	</div>
	<div class="modal-footer">
		<a
			(click)="confirmDeleteModalRef.hide()"
			class="btn theme-main-color-button"
			>Retour</a
		>
		<a class="btn theme-red-button ms-3" (click)="delete()">Supprimer</a>
	</div>
</ng-template>
